// removed by extract-text-webpack-plugin
module.exports = {"root":"_15e7u0Op4wcGWSNs0x6p-b","up":"_1g2-qI_d0gXu7Uhqli2_Jf","down":"_2E747YCmot2cIIc1IiCSdk","disabled":"_1SH575vZghasXnI4ZahuYc"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Input/Ticker/Ticker.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Input/Ticker/Ticker.scss
// module chunks = 0